<template>
	<div class="page" style="background-image: url(./images/form_bg.png); background-size: cover; overflow: auto;">
		<!-- 高新园用的招生 -->
		<div style="padding: 15px;">
			<div style="text-align: center; background-color: #fff; padding: 20px;">{{school_name}}</div>
			<van-cell-group>

				<van-field v-model="stuForm.stu_name" label="姓名" placeholder="请输入姓名" required />
				<van-cell title="性别" required>

					<template #right-icon>
						<van-radio-group v-model="stuForm.gender" direction="horizontal">
							<van-radio :name="1">男</van-radio>
							<van-radio :name="2">女</van-radio>
						</van-radio-group>
					</template>
				</van-cell>

				<van-field v-model="stuForm.phone" type="tel" label="手机号" placeholder="请输入手机号" required />
				<van-field v-model="stuForm.exam_num" label="准考证号" placeholder="请输入准考证号" required />

				<van-field v-model="stuForm.exam_score" type="number" label="总分" placeholder="请输入中考成绩" />


				<van-field v-model="stuForm.major_name" is-link readonly label="报考专业1" placeholder="请选择第一报考专业"
					@click="showMj1 = true" required />
				<van-popup v-model="showMj1" round position="bottom">
					<van-cascader v-model="stuForm.major_id" title="请选择报考专业" active-color="#1989fa" :options="majors"
						:field-names="fieldMajors" @close="showMj1 = false" @finish="onCheckMajor1" />
				</van-popup>

				<van-field v-model="stuForm.major_name2" is-link readonly label="报考专业2" placeholder="请选择第二报考专业"
					@click="showMj2 = true" />
				<van-popup v-model="showMj2" round position="bottom">
					<van-cascader v-model="stuForm.major_id2" title="请选择报考专业" active-color="#1989fa" :options="majors"
						:field-names="fieldMajors" @close="showMj2 = false" @finish="onCheckMajor2" />
				</van-popup>

				<van-field v-model="stuForm.major_name3" is-link readonly label="报考专业3" placeholder="请选择第三报考专业"
					@click="showMj3 = true" />
				<van-popup v-model="showMj3" round position="bottom">
					<van-cascader v-model="stuForm.major_id3" title="请选择报考专业" active-color="#1989fa" :options="majors"
						:field-names="fieldMajors" @close="showMj3 = false" @finish="onCheckMajor3" />
				</van-popup>




				<van-cell title="是否填写本校志愿" placeholder="是否填写本校志愿" required>
					<template #right-icon>
						<van-radio-group v-model="stuForm.volunteer" direction="horizontal">
							<van-radio :name="1">是</van-radio>
							<van-radio :name="0">否</van-radio>
						</van-radio-group>
					</template>
				</van-cell>

				<van-field v-model="stuForm.graduate_sch_city" is-link readonly label="毕业地区" placeholder="毕业地区"
					@click="showCity = true" required />
				<van-popup v-model="showCity" round position="bottom">
					<van-cascader v-model="distCode" title="请选择所在地区" active-color="#1989fa" :options="citys"
						:field-names="fieldNames" @close="showCity = false" @finish="onCheckCity"
						@change="cityChange" />
				</van-popup>

				<van-field v-model="stuForm.graduate_schname" is-link readonly  label="毕业学校" placeholder="毕业学校"
					@click="showSchool = true" required />
				<van-popup v-model="showSchool" round position="bottom">
					<van-cascader v-model="stuForm.graduate_schid" :readonly="stuForm.id" title="请选择毕业学校" active-color="#1989fa"
						:options="schools" :field-names="fieldSchools" @close="showSchool = false"
						@finish="onCheckSchool" @change="cityChange" />
				</van-popup>
				<van-field v-model="stuForm.graduate_schname2" v-if="stuForm.graduate_schid==0" label="学校名称"
					placeholder="毕业学校" required />


				<van-field v-model="stuForm.otherjson.tjr" label="校荐人" placeholder="请输入校荐人姓名" />
				<van-field v-model="stuForm.otherjson.tjr_phone" label="校荐联系电话" placeholder="请输入校荐人联系电话" />

				<van-field v-model="stuForm.remark" rows="2" autosize label="备注" type="textarea" maxlength="200"
					placeholder="请输入备注" show-word-limit />

				<div class="submitBtn flexCenter" v-if="showBtn">
					<div class="btn flexCenter" @click="saveStu">提交</div>
				</div>
				<div style="height:10px;"></div>


			</van-cell-group>
		</div>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	export default {

		data() {
			return {
				school_name: "",
				pmid: 0,
				openid: "",
				stuForm: {
					stu_name: "",
					phone: "",
					gender: "",
					exam_score: "",
					graduate_sch_city: "",
					graduate_schid: -1,
					graduate_schname: "",
					graduate_schname2: "",
					graduate_dist_code: "",
					major_id: "",
					major_id2: '',
					major_id3: '',
					major_name: "",
					major_name2: "",
					major_name3: "",
					volunteer: '',
					oldname: '',
					exam_num: '',
					remark: "",
					otherjson: {
						tjr: "",
						tjr_phone: ""
					}
				},
				showCity: false,
				showSchool: false,
				citys: [],
				schools: [],
				majors: [],
				distCode: '',
				fieldNames: {
					text: 'label',
					value: 'code',
					children: 'children',
				},
				fieldSchools: {
					text: 'school_name',
					value: 'id',
					children: 'children',
				},
				fieldMajors: {
					text: 'title',
					value: 'id',
					children: 'children',
				},
				showMj1: false,
				showMj2: false,
				showMj3: false,
				showBtn: false
			}
		},
		mounted() {
			$(".page").height($(window).height())
			document.title = "新生报名"
			this.pmid = this.$route.query.pmid
			this.openid = this.$route.query.openid
			window.pmid = this.pmid

			this.getStudents()
		},
		methods: {
			getStudents() {

				this.$http.post("/api/app_stuinfo", {
					pmid: this.pmid,
					openid: this.openid
				}).then(res => {
					if (res.data) {
						if (!res.data.otherjson) {
							res.data.otherjson = {
								tjr: "",
								tjr_phone: ""
							}
						}else{
							res.data.otherjson = JSON.parse(res.data.otherjson)
						}
						this.stuForm = res.data
					} else {
						this.showBtn = true
					}

					this.getSchoolName()
					this.getSchoolArea()
					this.getMajorList()
				})
			},
			getSchoolName() {
				this.$http.post("/api/app_platform_info", {
					pmid: this.pmid
				}).then(res => {
					this.school_name = res.data.platform
				})
			},
			getSchools() {

				this.$http.post("/api/app_area_school_list", {
					pmid: this.pmid,
					dist_code: this.distCode
				}).then(res => {
					res.data.push({
						id: 0,
						school_name: "其他学校"
					})
					this.schools = res.data
				})
			},
			getSchoolArea() {

				this.$http.post("/api/sys_finish_school_area", {
					pmid: this.pmid
				}).then(res => {
					for (let a of res.data) {
						for (let b of a.children) {
							for (let c of b.children) {
								delete c.children
							}
						}
					}
					this.citys = res.data
					console.log(this.citys)
				})
			},
			cityChange(e) {
				console.log(e)
			},
			onCheckCity({
				selectedOptions
			}) {
				this.showCity = false;

				this.stuForm.graduate_sch_city = selectedOptions.map((option) => option.label).join(',');
				this.stuForm.graduate_dist_code = selectedOptions[2].code
				this.getSchools()
			},
			onCheckSchool({
				selectedOptions
			}) {
				this.showSchool = false;
				this.stuForm.graduate_schid = selectedOptions.map((option) => option.id).join(',');
				this.stuForm.graduate_schname = selectedOptions.map((option) => option.school_name).join(',');
			},
			onCheckMajor1(e) {
				this.stuForm.major_id = e.selectedOptions[0].id
				this.stuForm.major_name = e.selectedOptions[0].title
				this.showMj1 = false
			},
			onCheckMajor2(e) {
				this.stuForm.major_id2 = e.selectedOptions[0].id
				this.stuForm.major_name2 = e.selectedOptions[0].title
				this.showMj2 = false
			},
			onCheckMajor3(e) {
				this.stuForm.major_id3 = e.selectedOptions[0].id
				this.stuForm.major_name3 = e.selectedOptions[0].title
				this.showMj3 = false
			},
			getMajorList() {
				this.$http.post("/api/app_major_list", {
					pmid: this.pmid,
					node_type: "major"
				}).then(res => {
					this.majors = res.data
					if (this.stuForm.major_id) {
						for (let item of res.data) {
							if (item.id == this.stuForm.major_id) {
								this.stuForm.major_name = item.title
							}
						}
					}
					if (this.stuForm.major_id2) {
						for (let item of res.data) {
							if (item.id == this.stuForm.major_id2) {
								this.stuForm.major_name2 = item.title
							}
						}
					}
					if (this.stuForm.major_id3) {
						for (let item of res.data) {
							if (item.id == this.stuForm.major_id3) {
								this.stuForm.major_name3 = item.title
							}
						}
					}


				})

			},
			saveStu() {

				if (!this.stuForm.stu_name) {
					Toast('请输入姓名');
					return
				}
				if (!this.stuForm.gender) {
					Toast('请选择性别');
					return
				}
				if (!this.stuForm.phone) {
					Toast('请输入手机号');
					return
				}
				if (!this.stuForm.exam_num) {
					Toast('请输入准考证号');
					return
				}
				if (!this.stuForm.major_id) {
					Toast('请选择报考专业');
					return
				}
				if (this.stuForm.volunteer === '') {
					Toast('请选择是否报考');
					return
				}
				if (!this.stuForm.graduate_sch_city) {
					Toast('请选择毕业地区');
					return
				}
				if (!this.stuForm.graduate_schname) {
					Toast('请选择或输入学校名称');
					return
				}
				if (this.stuForm.graduate_schname == '其他学校' && !this.stuForm.graduate_schname2) {
					Toast('请输入学校名称');
					return
				}
				this.stuForm.pmid = window.pmid
				this.stuForm.openid = this.openid
				this.$http.post("/api/app_stu_form", this.stuForm).then(res => {

					if (res.data.id) {


						Toast.success('报名成功，请耐心等待审核~');
						this.showBtn = false

					}
				})


			}
		},
	}
</script>

<style lang="less" type="text/less">
	.submitBtn {
        margin-top: 2vh;
		margin-bottom: 50px;

        .btn {
            display: inline-block;
            padding: 1.4vh 8%;
            background-color: #00CFDC;
            color: #fff;
            font-size: 15px;
            border-radius: 5vw;
			width: 50%;
			text-align:center;
        }
		.btn:active {
		  
		    background-color: #007AFF;
		   
		}
    }
</style>
